<template>
    <div class="home-container">
      <div class="d-flex flex-column align-items-center justify-content-center gap-3">
        <h5 class="extra-large-text">დაამატეთ პოზიცია</h5>
        <form class="add-organization-form modal-form-grid-wrapper p-4 border-radius-10" @submit.prevent="addPositions">
          <fieldset class="d-flex flex-column align-items-start gap-1 light-gray-color light-text">
            <label for="positionName" class="ms-2">პოზიციის სახელი(ქართულად)</label>
            <input v-model="positionDataVModels.position" type="text" autocomplete="off" name="positionName" id="positionName" required placeholder="პოზიციის სახელი(ქართულად)" class="blue-part-input large-text">
          </fieldset>
          <fieldset class="d-flex flex-column align-items-end gap-1 light-gray-color light-text">
            <label for="positionEngName" class="ms-2">(ინგლისურად)პოზიციის სახელი</label>
            <input v-model="positionDataVModels.positioneng" type="text" autocomplete="off" name="positionEngName" id="positionEngName" required placeholder="(ინგლისურად)პოზიციის სახელი" class="blue-part-input large-text">
          </fieldset>
          <fieldset class="d-flex flex-column align-items-start gap-1 light-gray-color light-text">
            <label for="officeID" class="ms-2">მონიშნეთ ოფისი</label>
            <Multiselect v-for="(data, i) of multiselectArray" name="officeID" id="officeID" v-model="positionDataVModels.officeID" :options="data.options" :mode="data.mode"
                :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1"
                :hideSelected="true" locale="ge" :canDeselect="false" :canClear="false" :required="true"
                class="extra-light-text light-blue-color" autocomplete="off" :placeholder="data.placeholder" :disabled="data.isDisabled" insert/>
          </fieldset>
          
          <div class="button-wrapper d-flex justify-content-center w-100">
            <secondaryButton :disabled="isSending" buttonWidth="max-content" buttonType="submit" class="large-text mt-4">
                <template v-slot:content>
                    დამატება
                </template>
            </secondaryButton>
          </div>
        </form>
      </div>
    </div>
</template>
<script>
import secondaryButton from "@/components/secondaryButton.vue"
import Multiselect from '@vueform/multiselect'
import DOMPurify from 'dompurify';
export default {
  data(){
    return {
      positionDataVModels: {
        position: "",
        positioneng: "",
        officeID: null,
      },
      multiselectArray: [
        {
          placeholder: "ოფისი",
          options: [],
          Vmodel: null,
          sendName: "municipaliteti",
          mode: "single",
          isDisabled: false,
        },
      ],
      isSending: false,
    }
  },
  components: {
    secondaryButton,
    Multiselect,
  },
  mounted(){
    this.getOffices();
  },
  methods: {
    getOffices(){
      this.$store.dispatch("getOffices").then((response) => {
        let tempArray = [];
        for(let office of response.data){
            tempArray.push({
                value: office.officeID,
                label: {
                    ge: office.office_name,
                    en: office.office_nameeng,
                },
            });
        }
        
        this.multiselectArray[0].options = tempArray;
      })
    },
    addPositions(){
      // let isPositionValid = this.$helper.checkString(this.positionDataVModels.position);
      // let isEngPositionValid = this.$helper.checkEngString(this.positionDataVModels.positioneng);
      // let isOfficeIDValid = this.$helper.checkNumber(this.positionDataVModels.officeID);

      // let sanitazedObj = {};
      // Object.keys(this.positionDataVModels).forEach((key) => {
      //   sanitazedObj[key] = this.$helper.decodeHtml(this.$helper.sanitazeAndPermitURI(this.positionDataVModels[key]));
      // });
      

      if(this.positionDataVModels.position && this.positionDataVModels.positioneng && this.positionDataVModels.officeID){
        this.isSending = true;
        const formData = new FormData();
        for(let key of Object.keys(this.positionDataVModels)){
          formData.append(key, this.positionDataVModels[key]);
        }

        this.$store.dispatch("addPositions", formData).then((response) => {
          if(response.status == 201){
            this.$helper.showSwal("პოზიცია წარმატებით დაემატა", "success", "");
            setTimeout(() => {this.$router.go()}, 1500);
          }
        }).catch((error) => {
          if(error?.response?.status == 422){
            this.$helper.showSwal("მოხდა შეცდომა", "error", "");
            setTimeout(() => {this.$router.go()}, 1500);
          }
        }).finally(() => {
          this.isSending = false;
        })

      }
    }
  }
}
</script>
<style scoped>
input[type="checkbox"]{
    width: 30px;
    height: 30px;
    cursor: pointer;
}
.home-container{
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(1, min-content);
  row-gap: 1.5em;
}
.add-organization-form{
  background-color: var(--secondary-background-color);
  width: 60%;
}
.modal-form-grid-wrapper{
  /* width: 100%; */
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 1em;
  row-gap: 2em;
}
.modal-form-grid-wrapper .blue-part-input{
  padding-block: 15px;
  max-width: 400px;
}
.button-wrapper{
  grid-column: 1/3;
}
textarea.blue-part-input{
  width: 100%;
  resize: none;
}
.multiselect{
    --ms-placeholder-color: var(--light-blue);
    --ms-tag-bg: var(--light-blue);
    --ms-option-bg-selected: var(--light-blue);
    --ms-option-bg-selected-pointed: var(--light-blue);
    flex: 1;
    max-width: 235px;
    margin: 0;
}

@media screen and (max-width: 1800px) {
  .add-organization-form{
    width: 70%;
  }
  .modal-form-grid-wrapper{
    column-gap: 2em;
    row-gap: 3em;
  }
}

@media screen and (max-width: 1560px) {
  .modal-form-grid-wrapper{
    column-gap: 2em;
    row-gap: 2em;
  }
  .modal-form-grid-wrapper .blue-part-input{
    padding: 10px;
  }
}
@media screen and (max-width: 1200px) {
  .add-organization-form{
    width: 90%;
  }
}
</style>
